var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cc_ssc-block"},_vm._l((_vm.horizontal),function(inner,ind){return _c('g-switch-list1',{key:'cc_' + ind,staticClass:"cs_horizontal",attrs:{"horizontal-type":2,"title":inner.title,"chip":_vm.chip,"columns":5,"list":inner.list}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b027c0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageComponents/cc_ssc/cc_ssc-2.vue
// module id = null
// module chunks = 